<div class="modal-header">
  <span class="empty"></span>
</div>

<ion-content>
  <div class="main-wrapper">
    <div class="content">
      <span class="delete-wrapper">
      <div class="delete-table-main">
        <ion-text>Are you sure you want to delete 
          "<span>{{deleteItem}}</span>" ?
          </ion-text>
       </div>
    </span>
    <span>This action cannot be undone. Please double-check your decision before proceeding.</span>
      <div class="btn-wrapper">
        <span class="cancel">
          <ion-button (click)="dismiss()">Cancel</ion-button>
        </span>
        <span class="delete">
          <ion-button (click)="delete()">Delete</ion-button>
        </span>
      </div>
    </div>
  </div>
</ion-content>
